import { render } from "./BlogSearchItem.vue?vue&type=template&id=c3e5efe0&scoped=true"
import script from "./BlogSearchItem.vue?vue&type=script&lang=js"
export * from "./BlogSearchItem.vue?vue&type=script&lang=js"

import "./BlogSearchItem.vue?vue&type=style&index=0&id=c3e5efe0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e5efe0"]])

export default __exports__